import React from 'react';
import { useState, useEffect } from 'react';

import i18n from "i18next";

import { Form, Row } from 'react-bootstrap';

import t from '../Translation/Translation';
import { Loader } from 'citric_components';

//import AppRoutes from './components/Dashboard/AppRoutes';
//import SettingsPanel from './shared/SettingsPanel';
import Footer from './Footer';
import { CustomToast } from 'citric_components';
//import { Form as Survey } from 'citric_viewer';


import conf from '../../config.json';

import Logo from '../../logo.svg';
import ErrorBoundary from '../Error/ErrorBoundary';
import { logD, logE } from '../Util/Util';
import CardImg from '../../images/card.png';
import Customers from '../Customers/Customers';
import Projects from '../Projects/Projects';
import Releases from '../Releases/Releases';
import ReleasesAdm from '../Releases/ReleasesAdm';
import Responses from '../Responses/Responses';
import Launchs from '../Launchs/Launchs';
import LaunchsInterviewed from '../Launchs/LaunchsInterviewed';
import WebView from '../WebView/WebView';
import Layout from './Layout';
import Cati from '../cati/Cati';

import { BrowserRouter, Routes, Route, Navigate  } from 'react-router';
import { useIonViewWillEnter, IonRouterOutlet, IonPage, IonNav } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Viewer from '../Viewer/Viewer';
import BrandLift from '../BrandLifts/BrandLift';

export default function Dashboard(props) {
    logD("Dashboard", props);

    //const [lang, setLang] = useState(i18n.language);
    const [lang, setLang] = useState(i18n.resolvedLanguage);
    const [selectedLaunch, setSelectedLaunch] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [customers, setCustomers] = useState(null);
    const [projects, setProjects] = useState(null);
    const [project, setProject] = useState(null);
    const [userConfig, setUserConfig] = useState(null);
    const [launchs, setLaunchs] = useState(null);
    const [launch, setLaunch] = useState(null);
    const [badUrl, setBadUrl] = useState(false);
    const [url, setUrl] = useState(null);
    const [title, setTitle] = useState('');
    const [typeUrl, setTypeUrl] = useState('');
    const [reload, setReload] = useState(null);
    const [interviewer, setInterviewer] = useState(props.token.u);
    const [interviewed, setInterviewed] = useState(null);
    const [response, setResponse] = useState(null);
    const [release, setRelease] = useState(null);
    const [keyNote, setKeyNote] = useState(null);
    const [assign, setAssign] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [refreshData, setRefreshData] = useState(() => {return;});
    const [total, setTotal] = useState(0);
    const toggleShowToast = () => setShowToast(!showToast);

    async function handleError(response) {
        logD('Dashboard.handleError', response);
        if (!response.ok) {
            if(response.status === 401) {
                handleUnauthorized();
            } else if(response.status === 404) {
                //Handle 404

            } else {
                logE(response);
                setShowToast(true);
            }
        } else {
            return response.json();
        }
    }

    function handleUnauthorized() {
        logD('Dashboard.handleUnauthorized', "unauthorized");
        props.setToken(null);
    }

    async function getProjectsFromCustomer(cust) {
        console.log(cust);
        props.token.c = cust.idCustomer;
        await getProjects();
        setCustomer(cust);
    }

    useEffect(() => {
        if(props.token.r == 1 && customer == null) {
            getCustomers();
        } else {
            if(props.token.r != 0) {
                getUserConfig();
            }
            getProjects();
        }
    }, [props.token.token]);

    function getCustomers() {
        let fd = new URLSearchParams();
        fd.append("idC", props.token.c);
        fd.append("idU", props.token.u);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allCustomers';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => handleError(response))
        .then((data) => {
            logD("Customers", data);
            setCustomers(data);
        }).catch((e) => {
            setShowToast(true);
        });
    }

    async function getProjects() {
        let fd = new URLSearchParams();
        fd.append("idC", props.token.c);
        fd.append("idU", props.token.u);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allProjects';
        await fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => handleError(response))
        .then((data) => {
            logD("Dashboard", data);
            if(data && data.length == 1) {
                setProjects(data);
                setProject(data[0]);
            } else {
                setProjects(data);
            }
        }).catch((e) => {
            setShowToast(true);
        });
    }

    function getUserConfig() {
        let fd = new URLSearchParams();
        fd.append("idU", props.token.u);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/userConfig';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => handleError(response))
        .then((data) => {
            logD("User Config", data);
            if(data && data != null && data.message != null) {
                setUserConfig(JSON.parse(data.message));
            }
        }).catch((e) => {
            setShowToast(true);
        });
    }

    /*useIonViewWillEnter(async () => {
        console.log('useIonViewWillEnter');
        setProject(null);
    }, []);*/

    function goToSurvey(routerProps) {
        return <Viewer {...routerProps} urlParams={[]} path={"/app/" + launch.urls[0].data} launch={launch} setLaunch={setLaunch}/>
    }

    /*const router = createBrowserRouter(
        createRoutesFromElements(
                <>
                <Route path="/" element={<Navigate to="dashboard" />} />
                <Route path="dashboard" element={<Layout />}>
                    <Route index element={<Navigate to="projects" />} />
                    <Route path="projects" element={<Projects projects={projects} setProject={setProject} setLang={setLang} token={props.token} setToken={props.setToken}/>} />
                    <Route path="project/:id" element={<Releases project={project} projects={projects} setLang={setLang} token={props.token} setProject={setProject} setLaunch={setLaunch} setUrl={setUrl} setToken={props.setToken}/>} />
                    <Route exact path="history/:id" element={<Responses launch={launch} token={props.token} handleError={handleError} showToast={showToast} setUrl={setUrl} setLaunch={setLaunch} reload={reload}/>} />
                    <Route exact path="webview/:id" element={<WebView url={url} setUrl={setUrl} launch={launch} setLaunch={setLaunch} setReload={setReload}/>} />
                    <Route path="*" element={<>No match dash</>} />
                </Route>
                <Route path="*" element={<>No match</>} />
                </>
        )
    );*/

    return (
        <>
            {
                props.token.r == 1 ? console.log('R 1') : console.log('R != 1')
            }
            {((props.token.r == 1 && customers == null) || (props.token.r != 1 && projects == null)) && <Loader />}
            {((props.token.r == 1 && customers != null) || (props.token.r != 1 && projects != null)) && <>
                {/*<RouterProvider router={router} />*/}
            {<BrowserRouter>
                <Routes>
                    <Route path="/" element={<Navigate to="dashboard" />} />
                    <Route path="dashboard" element={<Layout />}>
                        <Route index element={
                            (props.token.r == 1 && customer == null) ? <Navigate to="customers" /> : <Navigate to="projects" />
                        } />
                        <Route path="customers" element={
                            (props.token.r == 1 && customer == null) ? 
                            <Customers customers={customers} getProjectsFromCustomer={getProjectsFromCustomer} lang={lang} setLang={setLang} setUrl={setUrl} setTitle={setTitle} setTypeUrl={setTypeUrl} token={props.token} setToken={props.setToken}/>
                            : <Navigate to="projects" />
                        } />
                        <Route path="projects" element={
                            projects != null ?
                            (projects.length == 0 || projects.length > 1) ?
                            <Projects projects={projects} setProject={setProject} lang={lang} setLang={setLang} setUrl={setUrl} setTitle={setTitle} setTypeUrl={setTypeUrl} 
                                token={props.token} setToken={props.setToken} setCustomer={setCustomer} setShowToast={setShowToast} handleError={handleError} setRefreshData={setRefreshData}/>
                            : <Navigate to={"../project/" + project.idProject} replace />
                            : <Navigate to="/dashboard" replace />
                        } />
                        <Route path="project/:id" element={
                            project != null ?
                            (
                                props.token.r == 4 ? 
                                    <Releases project={project} projects={projects} lang={lang} setLang={setLang} token={props.token} 
                                        setProject={setProject} setLaunch={setLaunch} setUrl={setUrl} setTitle={setTitle} setInterviewer={setInterviewer}
                                        setTypeUrl={setTypeUrl} setToken={props.setToken} setKeyNote={setKeyNote} handleError={handleError} userConfig={userConfig}/>
                                : (props.token.r == 0 ? <LaunchsInterviewed token={props.token} handleError={handleError} setShowToast={setShowToast} 
                                    setUrl={setUrl} setLaunch={setLaunch} project={project} projects={projects} lang={lang} setLang={setLang} setToken={props.setToken}
                                    setTitle={setTitle} setTypeUrl={setTypeUrl} setInterviewer={setInterviewer} setInterviewed={setInterviewed} setResponse={setResponse} response={response} setKeyNote={setKeyNote}/>
                                    : (project.type != 4) ? <ReleasesAdm project={project} projects={projects} lang={lang} setLang={setLang} token={props.token} setUrl={setUrl} setTitle={setTitle} setTypeUrl={setTypeUrl} 
                                    setProject={setProject} setRelease={setRelease} setToken={props.setToken} handleError={handleError} setCustomer={setCustomer} setShowToast={setShowToast}
                                    refreshData={refreshData} userConfig={userConfig} setTotal={setTotal}/>
                                    : <BrandLift project={project} projects={projects} lang={lang} setLang={setLang} token={props.token} setUrl={setUrl} setTitle={setTitle} setTypeUrl={setTypeUrl} 
                                    setProject={setProject} setRelease={setRelease} setToken={props.setToken} handleError={handleError} setCustomer={setCustomer} setShowToast={setShowToast}  />
                                    )
                            )
                            : <Navigate to="/dashboard" replace />
                        } />
                        <Route exact path="history/:id" element={
                            launch != null ?
                            <Responses launch={launch} token={props.token} handleError={handleError} setShowToast={setShowToast} 
                                setUrl={setUrl} setLaunch={setLaunch} interviewer={interviewer} lang={lang}
                                setTitle={setTitle} setTypeUrl={setTypeUrl} reload={reload} setKeyNote={setKeyNote} total={total}/>
                            : <Navigate to="/dashboard" replace />
                        } />
                        <Route exact path="release/:id" element={
                            release != null ?
                            <Launchs release={release} token={props.token} setToken={props.setToken} handleError={handleError} setShowToast={setShowToast} 
                                setUrl={setUrl} setLaunch={setLaunch} project={project} setRelease={setRelease}
                                setTitle={setTitle} setTypeUrl={setTypeUrl} setInterviewer={setInterviewer} setKeyNote={setKeyNote} userConfig={userConfig} setTotal={setTotal}/>
                            : <Navigate to="/dashboard" replace />
                        } />
                        <Route exact path="webview/:id" element={
                            url != null ?
                            <WebView url={url} setUrl={setUrl} launch={launch} setLaunch={setLaunch} setReload={setReload} title={title} type={typeUrl}
                              token={props.token} setToken={props.setToken} handleError={handleError} setShowToast={setShowToast} keyNote={keyNote} interviewer={interviewer} interviewed={interviewed} assign={assign}
                              response={response} userConfig={userConfig} setResponse={setResponse}/>
                            : <Navigate to="/dashboard" replace />
                            //<WebView url={url} setUrl={setUrl} launch={launch} setLaunch={setLaunch} setReload={setReload}/>
                        } />
                        <Route exact path="cati/:id" element={
                            launch != null ?
                            <Cati launch={launch} token={props.token} setToken={props.setToken} handleError={handleError} setShowToast={setShowToast} 
                                setUrl={setUrl} setLaunch={setLaunch} interviewer={interviewer} lang={lang}
                                setTitle={setTitle} setTypeUrl={setTypeUrl} reload={reload} setKeyNote={setKeyNote} setAssign={setAssign}/>
                            : <Navigate to="/dashboard" replace />
                            //<WebView url={url} setUrl={setUrl} launch={launch} setLaunch={setLaunch} setReload={setReload}/>
                        } />
                        <Route path="*" element={
                            <Navigate to="/dashboard" replace />
                        } />
                    </Route>
                    <Route path="*" element={<>No match</>} />
                </Routes>
            </BrowserRouter>}
            {/*<IonReactRouter>
            <IonRouterOutlet>*/}
                    {/*<Route exact path="/" >
                        <Redirect exact from="/" to="/dashboard" />
                    </Route>
                    <Route exact path="/dashboard" >
                        {
                            project == null &&
                            <Redirect exact from="/dashboard" to="/dashboard/projects" />
                        }
                        {
                            (project != null && launch == null && projects.length == 1) &&
                            <Redirect exact from="/dashboard" to={"/dashboard/project/" + project.idProject} /> 
                        }
                    </Route>
                    <Route exact path="/dashboard/projects">
                        {
                            (projects.length == 1) &&
                            <Redirect exact from="/dashboard/projects" to={"/dashboard/project/" + project.idProject} />
                        }
                        {
                            (projects.length == 0 || projects.length > 1) &&
                            <Projects projects={projects} setProject={setProject} setLang={setLang} token={props.token} setToken={props.setToken}/>
                        }
                    </Route>
                    <Route exact path="/dashboard/project/:id">
                        {
                            project != null && 
                            <Releases launchs={project.launchsDash} projects={projects} setLang={setLang} token={props.token} setProject={setProject} setLaunch={setLaunch} setUrl={setUrl} setToken={props.setToken}/>
                        }
                        {
                            //(project != null && launch != null) &&
                            <Redirect exact to="/dashboard/survey" />
                        }
                        {
                            project == null &&
                            <Redirect exact to="/dashboard/projects" /> 
                        }
                    </Route>*/}
                    {/*<Route exact path="/dashboard/survey">
                        {
                            launch != null &&
                            <Viewer urlParams={[]} path={"/app/" + launch.urls[0].data} launch={launch} setLaunch={setLaunch}/>
                        }
                        {
                            (launch == null) &&
                            <Redirect exact to="/dashboard/projects" />
                        }
                        {
                            (project == null) &&
                            <Redirect exact to="/dashboard/projects" />
                        }
                    </Route>*/}
                    {/*<Route exact path="/dashboard/history/:id">
                        {
                            launch != null &&
                            <Responses launch={launch} token={props.token} handleError={handleError} showToast={showToast} setUrl={setUrl} setLaunch={setLaunch} reload={reload}/>
                        }
                        {
                            (launch == null) &&
                            <Redirect exact to="/dashboard/projects" />
                        }
                        {
                            (project == null) &&
                            <Redirect exact to="/dashboard/projects" />
                        }
                    </Route>
                    <Route exact path="/dashboard/webview/:id">
                        {
                            url != null &&
                            <WebView url={url} setUrl={setUrl} launch={launch} setLaunch={setLaunch} setReload={setReload}/>
                        }
                        {
                            (launch == null) &&
                            <Redirect exact to="/dashboard/projects" />
                        }
                        {
                            (project == null) &&
                            <Redirect exact to="/dashboard/projects" />
                        }
                    </Route>*/}
                {/*</IonRouterOutlet>
                </IonReactRouter>*/}
                </>
            }
        </>
    );
}